import './App.css';
import EpubDirectory from './components/EpubDirectory';

function App() {
  return (
    <div className="App">
      <EpubDirectory />
    </div>
  );
}



export default App;
